<!-- 运维视图: 交接班 -->
<template>
    <el-row style="margin-top:10px;" type="flex">
        <operation-board-crew :span="11" :duties="duties" :duty-key="'first'" @after-add="emitAfterAdd"
                              @after-accept="emitAfterAccept" @after-handover="emitAfterHandover">
        </operation-board-crew>
        <el-col :span="2" class="midarrow" style="text-align:center;">
            <i class="el-icon-d-arrow-right arrow-icon">
            </i>
        </el-col>
        <operation-board-crew :span="11" :duties="duties" :duty-key="'second'" @after-add="emitAfterAdd"
                              @after-accept="emitAfterAccept" @after-handover="emitAfterHandover">
        </operation-board-crew>
    </el-row>
</template>

<script>
    import OperationBoardCrew from './operation-board-crew';

    export default {
        name: "operation-board-duty",
        components: {
            OperationBoardCrew
        },
        props: {
            duties: {},
        },
        data() {
            return {
            };
        },
        methods: {
            emitAfterAdd(data) {
                this.$emit('after-add', data);
            },
            emitAfterAccept(data) {
                this.$emit('after-accept', data);
            },
            emitAfterHandover(data) {
                this.$emit('after-handover', data);
            },
        },
        mounted() {
        },
    }
</script>

<style scoped>

</style>
